import ActionTypes from '../constants/ActionTypes';
import decode from 'jwt-decode';

export function getUserInfoForGQ(state) {
  const { user } = state;
  if (!user.data || !user.data.logged_in) {
    return {
      loggedIn: false
    };
  }
  const { username, email, phone } = user.data;
  return {
    loggedIn: true,
    name: username,
    email,
    phone
  };
}

export function getUserLoginState(state) {
  const { user } = state;
  if (!user.data)
    return {
      id: -1,
      loggedIn: true,
      connectedToFacebook: false,
      isNewUser: false,
      supportThreadId: 0,
      supportUnreadCount: 0,
      supportMessageId: 0
    };
  return {
    id: user.data.user_id,
    loggedIn: user.data.logged_in,
    connectedToFacebook: user.data.fb_connected,
    isNewUser: user.data.is_new_user,
    facebookUrl: user.data.facebook_login_url,
    email: user.data.email,
    supportThreadId: user.data.support_thread_id,
    supportUnreadCount: user.data.support_unread_count,
    supportMessageId: user.data.support_message_id,
    isPasswordSet: user.data.is_password_set,
    firstName: user.data.first_name,
    surname: user.data.surname
  };
}

const decodeToken = token => {
  try {
    return decode(token);
  } catch (e) {
    return null;
  }
};

export function hasToken(state) {
  const { user } = state;
  if (user.token.value) {
    const token = user.token.value;
    const decoded = decodeToken(token);
    if (!decoded) return false;
    return decoded.exp > Math.floor(Date.now() / 1000);
  }
  return false;
}

export function getToken(state) {
  const { user } = state;
  if (!hasToken(state)) {
    return;
  }
  return user.token.value;
}

export function hasAttemptedLogin(state) {
  const { user } = state;
  return user.status !== ActionTypes.USER_LOGIN_CHECK_UNKNOWN;
}

export function getFacebookLoginUrl(state) {
  const { user } = state;
  return user.data && user.data.facebook_login_url;
}

export function getPasswordState(state) {
  const { user } = state;
  return user.passwordStatus;
}

export function getConnectFacebookState(state) {
  const { user } = state;
  return user.connectFacebookStatus;
}
